import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'

import { Grid, Button, ExpansionPanelDetails, Typography, ListItem } from '@material-ui/core'
import { EditableSwitch } from '../common/EditableComponents'
import { updateShopFeatures } from '../../actions/shop'

class OnFleetSettingInfoMemberNotes extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      enableNumberOfCompletedTransactions:
        (props.onfleetSettings && props.onfleetSettings.enableNumberOfCompletedTransactions) ||
        false,
      enableMemberId: (props.onfleetSettings && props.onfleetSettings.enableMemberId) || false,
      enableMemberGroup:
        (props.onfleetSettings && props.onfleetSettings.enableMemberGroup) || false,
      enableConsumerType:
        (props.onfleetSettings && props.onfleetSettings.enableConsumerType) || false,
      enableJoinedDate: (props.onfleetSettings && props.onfleetSettings.enableJoinedDate) || false,
      enableLastVisitDate:
        (props.onfleetSettings && props.onfleetSettings.enableLastVisitDate) || false,
      enableDOB: (props.onfleetSettings && props.onfleetSettings.enableDOB) || false,
      enableTotalLoyaltyPoints:
        (props.onfleetSettings && props.onfleetSettings.enableTotalLoyaltyPoints) || false,
      enableEstimatedPointsEarnedOnOrder:
        (props.onfleetSettings && props.onfleetSettings.enableEstimatedPointsEarnedOnOrder) ||
        false,
      enableMemberTags: (props.onfleetSettings && props.onfleetSettings.enableMemberTags) || false,
    }
  }

  updateShopFeatures = (onfleetSettings) => {
    const { shopFeatures = [] } = this.props

    shopFeatures.onfleetSetting = onfleetSettings

    this.props.dispatch(updateShopFeatures(shopFeatures)).then((res) => {
      this.toggleEdit()
    })
  }

  onChange = (key, value, isSelect) => (e) => {
    if (isSelect) {
      this.setState({ [key]: e.target.value })
    } else {
      this.setState({ [key]: !value })
    }
  }

  toggleEdit = () => {
    this.setState({
      editMode: !this.state.editMode,
      enableNumberOfCompletedTransactions:
        (this.props.onfleetSettings &&
          this.props.onfleetSettings.enableNumberOfCompletedTransactions) ||
        false,
      enableMemberId:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableMemberId) || false,
      enableMemberGroup:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableMemberGroup) || false,
      enableConsumerType:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableConsumerType) || false,
      enableJoinedDate:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableJoinedDate) || false,
      enableLastVisitDate:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableLastVisitDate) || false,
      enableDOB: (this.props.onfleetSettings && this.props.onfleetSettings.enableDOB) || false,
      enableTotalLoyaltyPoints:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableTotalLoyaltyPoints) ||
        false,
      enableEstimatedPointsEarnedOnOrder:
        (this.props.onfleetSettings &&
          this.props.onfleetSettings.enableEstimatedPointsEarnedOnOrder) ||
        false,
      enableMemberTags:
        (this.props.onfleetSettings && this.props.onfleetSettings.enableMemberTags) || false,
    })
  }

  onUpdate = () => {
    const { onfleetSettings = {} } = this.props
    const {
      enableNumberOfCompletedTransactions,
      enableMemberId,
      enableMemberGroup,
      enableConsumerType,
      enableJoinedDate,
      enableLastVisitDate,
      enableDOB,
      enableTotalLoyaltyPoints,
      enableEstimatedPointsEarnedOnOrder,
      enableMemberTags,
    } = this.state
    onfleetSettings.enableNumberOfCompletedTransactions = enableNumberOfCompletedTransactions
    onfleetSettings.enableMemberId = enableMemberId
    onfleetSettings.enableMemberGroup = enableMemberGroup
    onfleetSettings.enableConsumerType = enableConsumerType
    onfleetSettings.enableJoinedDate = enableJoinedDate
    onfleetSettings.enableLastVisitDate = enableLastVisitDate
    onfleetSettings.enableDOB = enableDOB
    onfleetSettings.enableTotalLoyaltyPoints = enableTotalLoyaltyPoints
    onfleetSettings.enableEstimatedPointsEarnedOnOrder = enableEstimatedPointsEarnedOnOrder
    onfleetSettings.enableMemberTags = enableMemberTags

    this.updateShopFeatures(onfleetSettings)
  }

  render() {
    const {
      editMode = false,
      enableNumberOfCompletedTransactions = false,
      enableMemberId = false,
      enableMemberGroup = false,
      enableConsumerType = false,
      enableJoinedDate = false,
      enableLastVisitDate = false,
      enableDOB = false,
      enableTotalLoyaltyPoints = false,
      enableEstimatedPointsEarnedOnOrder = false,
      enableMemberTags = false,
    } = this.state

    return (
      <ExpansionPanelDetails>
        <div className="full-width">
          {!editMode ? (
            <Button className="primary-button pull-right" onClick={this.toggleEdit}>
              {' '}
              Edit{' '}
            </Button>
          ) : (
            <div className="pull-right margin-bottom-small">
              <Button className="primary-button margin" onClick={this.onUpdate}>
                Save
              </Button>
              <Button className="danger-button margin" onClick={this.toggleEdit}>
                Cancel
              </Button>
            </div>
          )}
          <Grid container className="listing-spacing">
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Member ID</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableMemberId}
                      onChange={this.onChange('enableMemberId', enableMemberId)}
                      valueToRender={enableMemberId ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Member Group</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableMemberGroup}
                      onChange={this.onChange('enableMemberGroup', enableMemberGroup)}
                      valueToRender={enableMemberGroup ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Member Tags</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableMemberTags}
                      onChange={this.onChange('enableMemberTags', enableMemberTags)}
                      valueToRender={enableMemberTags ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Consumer Type</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableConsumerType}
                      onChange={this.onChange('enableConsumerType', enableConsumerType)}
                      valueToRender={enableConsumerType ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>DOB</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableDOB}
                      onChange={this.onChange('enableDOB', enableDOB)}
                      valueToRender={enableDOB ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Joined Date</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableJoinedDate}
                      onChange={this.onChange('enableJoinedDate', enableJoinedDate)}
                      valueToRender={enableJoinedDate ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Last Visit Date</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableLastVisitDate}
                      onChange={this.onChange('enableLastVisitDate', enableLastVisitDate)}
                      valueToRender={enableLastVisitDate ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Number of Completed Transactions</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableNumberOfCompletedTransactions}
                      onChange={this.onChange(
                        'enableNumberOfCompletedTransactions',
                        enableNumberOfCompletedTransactions,
                      )}
                      valueToRender={enableNumberOfCompletedTransactions ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Total Loyalty Points</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableTotalLoyaltyPoints}
                      onChange={this.onChange('enableTotalLoyaltyPoints', enableTotalLoyaltyPoints)}
                      valueToRender={enableTotalLoyaltyPoints ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Estimated Points Earned on order</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableEstimatedPointsEarnedOnOrder}
                      onChange={this.onChange(
                        'enableEstimatedPointsEarnedOnOrder',
                        enableEstimatedPointsEarnedOnOrder,
                      )}
                      valueToRender={enableEstimatedPointsEarnedOnOrder ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
          </Grid>
        </div>
      </ExpansionPanelDetails>
    )
  }
}

export default connect(({ dispatch }) => ({ dispatch }))(OnFleetSettingInfoMemberNotes)



// WEBPACK FOOTER //
// ./src/components/OnFleet/OnFleetSettingInfoMemberNotes.js